import { UnderlineTabs } from '../../../../components/ui-components/UnderlineTabs'

type PlanTab = 'EQUITY' | 'NON_EQUITY'

type PlanTabsProps = {
    activeTab: PlanTab
    onChange: (tab: PlanTab) => void
}

const TABS = [
    { value: 'EQUITY' as const, label: 'Equity' },
    { value: 'NON_EQUITY' as const, label: 'Non-equity' }
]

export function PlanTabs({ activeTab, onChange }: PlanTabsProps) {
    return (
        <UnderlineTabs
            tabs={TABS}
            activeTab={activeTab}
            onChange={onChange}
        />
    )
}
